/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { Fragment } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { DenseListCard } from '../../../../shared/surface-cards/DenseListCard';
import { settingsStyles } from '../../../../settings/screens/settingsScreen.styles';
import { ticketColors } from '../../../../shared/theme/ticketColors';
import { empPermStyles } from './employeePermissions.styles';
import { getInitials } from '../../../teamUtils';
import { formatLocalDate } from '@shared/vueltoDateTime';
import type { EmployeePermissionsVm } from './useEmployeePermissions';
import { invitationRoleLabel } from './EmployeeRolePresets';

type Props = {
  vm: EmployeePermissionsVm;
};

export function EmployeeRevokedTab({ vm }: Props) {
  const { filteredRevokedEmployees, busyKey, onReactivate, canRevoke } = vm;

  if (filteredRevokedEmployees.length === 0) {
    return (
      <View style={empPermStyles.emptyState} testID="perfil.team.revoked.empty">
        <Text style={empPermStyles.emptyTitle}>Sin empleados revocados</Text>
        <Text style={empPermStyles.emptySubtitle}>
          Los que sacaste aparecen acá. Los reactivás cuando quieras.
        </Text>
      </View>
    );
  }

  return (
    <Fragment>
      {filteredRevokedEmployees.map((employee) => (
        <DenseListCard key={employee.id} wrapStyle={empPermStyles.cardRevoked}>
          <View style={empPermStyles.cardHeader}>
            <View style={empPermStyles.cardHeaderLeft}>
              <View style={[empPermStyles.avatar, { backgroundColor: ticketColors.bad + '20' }]}>
                <Text style={[empPermStyles.avatarText, { color: ticketColors.bad }]}>
                  {getInitials(employee.name)}
                </Text>
              </View>
              <View style={empPermStyles.cardHeaderInfo}>
                <Text style={settingsStyles.cardTitle}>{employee.name}</Text>
                <Text style={settingsStyles.caption}>
                  {invitationRoleLabel(employee.role)}
                  {employee.email ? ` · ${employee.email}` : ''}
                </Text>
                <Text style={empPermStyles.revokedHint}>
                  Ya no puede entrar a la app.
                  {employee.createdAt ? ` Alta: ${formatLocalDate(employee.createdAt)}` : ''}
                </Text>
              </View>
            </View>
            {canRevoke ? (
            <TouchableOpacity
              style={empPermStyles.reactivateBtn}
              onPress={() => onReactivate(employee.id, employee.name)}
              disabled={busyKey === `reactivate-${employee.id}`}
              accessibilityRole="button"
              accessibilityLabel={`Reactivar acceso de ${employee.name}`}
              testID="perfil.team.revoked.reactivate"
            >
              <Ionicons name="person-add-outline" size={14} color={ticketColors.gold} />
              <Text style={empPermStyles.reactivateBtnLabel}>Reactivar</Text>
            </TouchableOpacity>
            ) : null}
          </View>
        </DenseListCard>
      ))}
    </Fragment>
  );
}
